export default __webpack_public_path__ + "static/media/QR-HR.43754bdb.png";